export const GET_ALL_USERS_REQUEST = " GET_ALL_USERS_REQUEST";
export const GET_ALL_USERS_SUCCESS = " GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILURE = " GET_ALL_USERS_FAILURE";